import { render, staticRenderFns } from "./FilterDrawerWelcomeMessage.vue?vue&type=template&id=3cbbbedc"
import script from "./FilterDrawerWelcomeMessage.vue?vue&type=script&lang=js"
export * from "./FilterDrawerWelcomeMessage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports